import React from "react";
import {
  EXAM_STATUS_COLORS,
  EXAM_STATUS_LABELS,
} from "../../utils/examsschedule/examConstants";
import { Badge } from "../../components/ui";

export default function ExamStatusBadge({ status }) {
  const cls = EXAM_STATUS_COLORS[status] || "bg-neutral-100 dark:bg-neutral-800 text-neutral-600 dark:text-neutral-300";
  const label = EXAM_STATUS_LABELS[status] || status || "—";
  return (
    <Badge className={`text-[10px] font-semibold px-2 py-0.5 border-0 ${cls}`}>
      {label}
    </Badge>
  );
}